// extracted by mini-css-extract-plugin
export var actions = "_hz-d";
export var benefitCard = "_hz-a";
export var benefitIcon = "_hz-b";
export var benefitLabel = "_hz-c";
export var benefits = "_hz-9";
export var bodyText = "_hz-8";
export var closeButton = "_hz-2";
export var content = "_hz-3";
export var eyebrow = "_hz-4";
export var heading = "_hz-5";
export var image = "_hz-f";
export var imagePanel = "_hz-e";
export var modal = "_hz-0";
export var shell = "_hz-1";
export var title = "_hz-6";
export var titleOffer = "_hz-7";